import axios from "axios";

//const API_URL = "http://localhost:8080/api/auth/";
const API_URL = process.env.REACT_APP_API_URL;

export const login = async (username: string, password: string) => {
  const login_API_URL = API_URL + '/api/auth/signin';
  console.log("login_API_URL = "+login_API_URL);
  try {
    const response = await axios.post(login_API_URL, { username, password });
    console.log("response.data = ", response.data);
    if (response.data.token) {
        localStorage.setItem("user", JSON.stringify(response.data));
      }
    return response.data;
  } catch (error) {
    console.error("error = ", error);
    throw error;
  }
};
/*
export const login = (username: string, password: string) => {
    return axios
      .post(API_URL + "signin", {
        username,
        password,
      })
      .then((response) => {
        if (response.data.accessToken) {
          localStorage.setItem("user", JSON.stringify(response.data));
        }
  
        return response.data;
      });
  };
*/
export const register = (username: string, email: string, password: string) => {
  return axios.post(API_URL + "signup", {
    username,
    email,
    password,
  });
};

export const logout = () => {
  localStorage.removeItem("user");
};

export const getCurrentUser = () => {
  const userStr = localStorage.getItem("user");
  if (userStr) return JSON.parse(userStr);

  return null;
};